import { useState, useEffect, useRef } from 'react';
import { EventBroker } from '../../eventbroker';
import ActionsDrawer from './ActionsDrawer';
import ControlButton from './base/ControlButton';
import DrawerButton from './base/DrawerButton';

export default function ControlDrawer({
    defaultLabel, title, actions, ControlProps, currentId, ...rest
}) {
    const [controlLabel, setControlLabel] = useState(defaultLabel);

    // Keep the drawer face in sync with the ACTUAL display state, not just the
    // last click. Programmatic changes (macros, Gibbs, undo) publish
    // 'viewStateChanged'; re-derive the currently-active option and show its
    // face image — fixes e.g. all-hydrogens showing the polar icon after a
    // macro (or any non-click path) set the state. `currentId()` returns the
    // active option id; drawers without it keep the click-only behavior.
    const actionsRef = useRef(actions);
    actionsRef.current = actions;
    const currentIdRef = useRef(currentId);
    currentIdRef.current = currentId;
    useEffect(() => {
        if (!currentIdRef.current) return undefined;
        const sync = () => {
            const fn = currentIdRef.current;
            if (!fn) return;
            const activeId = fn();
            const active = actionsRef.current.find((a) => a.id === activeId);
            if (active) setControlLabel(active.label);
        };
        sync(); // reflect current state on mount
        const handler = EventBroker.subscribe('viewStateChanged', sync);
        return () => EventBroker.unsubscribe('viewStateChanged', handler);
    }, []);

    const control = <ControlButton title={title} {...ControlProps}>{controlLabel}</ControlButton>;
    const actionButtons = actions.map((action) => {
        const {
            id, desc, label, onClick,
        } = action;

        return (
            <DrawerButton
                key={id}
                title={desc}
                id={id}
                onClick={() => onClick(setControlLabel)}
            >
                {label}
            </DrawerButton>
        );
    });

    return (
        <ActionsDrawer control={control} {...rest}>
            {actionButtons}
        </ActionsDrawer>
    );
}

// TODO: proptypes
